// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

.carousel {
    position: relative;
    width: calc(min(90rem, 90%));
    margin: 0 auto;
    min-height: 100vh;
    column-gap: 3rem;
    padding-block: min(20vh, 3rem);
}

@media screen and (min-width: 48rem) {
    .carousel {
        display: flex;
        align-items: center;
    }
}

.carousel-content span {
    text-transform: uppercase;
    letter-spacing: 1.5px;
    font-size: 1rem;
    color: #717171;
}

.carousel-content h1 {
    text-transform: capitalize;
    letter-spacing: 0.8px;
    font-size: 4rem;
    line-height: 1.1;
    background-color: #00a4aa;
    background-image: linear-gradient(45deg, #00a4aa, #000);
    background-size: 100%;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
}

.carousel-content hr {
    display: block;
    background: #00a4aa;
    height: 0.25rem;
    width: 6.25rem;
    border: none;
    margin: 1.125rem 0 1.875rem 0;
}

.carousel-content p {
    line-height: 1.6;
}

.slider-btn {
    display: inline-block;
    color: #717171;
    background: #fff;
    padding: 0.625rem 1.875rem;
    margin-top: 2.125rem;
    text-decoration: none;
    text-transform: uppercase;
    border: 2px solid #c2c2c2;
    border-radius: 3.125rem;
    transition: 0.3s ease-in-out;
}

.slider-btn:hover {
    border: 0.125rem solid #00a4aa;
    color: #00a4aa;
}

.swiper-container {
    width: 100%;
    height: 470px;
    max-height: 470px;
    display: flex;
    justify-content: center;
    position: relative;
    margin-bottom: -25px;
}

.myswiper {
    width: 100%;
    max-width: 720px;

}

.myswiper-slider {
    width: 18.75rem;
    /* height: 28.125rem; */
    background-size: cover;
    background-position: center;

    /* @media screen and (max-width: 992px) {
        height: 160px;
    } */
}

.myswiper-slider div {
    display: none;
    opacity: 0;
    padding-bottom: 0.625rem;
}

.swiper-slide-active div {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    opacity: 1;
    background-color: rgba(0, 0, 0, 0.5);
    height: 100%;
}

.swiper-slide-active div a {
    align-self: flex-start;
}

.myswiper-slider h2 {
    color: #fff;
    font-weight: 400;
    font-size: 1.4rem;
    line-height: 1.4;
    margin-bottom: 0.625rem;
    padding: 0 0 0 1.563rem;
    text-transform: uppercase;
}

.myswiper-slider p {
    color: #dadada;
    padding: 0 1.563rem;
    line-height: 1.6;
    font-size: 0.75rem;
}

.myswiper-slider a {
    margin: 1.25rem 1.5rem 3.5rem;
}

.myswiper-slider a:hover {
    color: #00a4aa;
}

.swiper-pagination-bullet,
.swiper-pagination-bullet-active {
    background: #fff;
}

.swiper-slide-prev{
    opacity: 0.5;
}

.swiper-slide-next{
    opacity: 0.5;
}

.swiper-slide-active{
    opacity: 1;
}

.swiper-container .swiper-slide img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top;
}


.laptop-img {
    position: absolute;
    top: -15px;
    z-index: 10;
    width: 100%;
    max-width: 860px;

}

@media screen and (min-width: 576px) and (max-width: 992px) {
    .swiper-container {
        height: auto;
        max-height: 290px;
    }
   .swiper-container  .myswiper {
    width: 470px;
    height: 290px;
   }

   .laptop-img  {
    width: 570px;
    height: 340px;
   }
}

@media screen and  (max-width: 576px) {
    .swiper-container {
        max-height: 175px;
    }
    .swiper-container  .myswiper {
     width: 260px;
     height: 175px;
    }
 
    .laptop-img  {
     width: 320px;
     height: 200px;
     top: -5px;
    }
 }

/* @media screen and (min-width: 320px) and (max-width: 420px) {
    .laptop-img {
        width: 92%;
        height: 185px;
        bottom: -18px;
    }

    .myswiper {
        width: 75%;
    }
}

@media screen and (min-width: 421px) and (max-width: 520px) {
    .laptop-img {
        width: 70%;
        height: 185px;
        bottom: -18px;
    }

    .myswiper{
        width: 58%;
    }
}

@media screen and (min-width: 521px) and (max-width: 620px) {
    .laptop-img {
        width: 60%;
        height: 185px;
        bottom: -18px;
    }

    .myswiper{
        width: 50%;
    }
}

@media screen and (min-width: 621px) and (max-width: 720px) {
    .laptop-img {
        width: 80%;
        height: 330px;
        bottom: -33px;
    }

    .myswiper{
        width: 66%;
    }

    .myswiper-slider{
        height: 285px;
    }
}

@media screen and (min-width: 721px) and (max-width: 820px) {
    .laptop-img {
        width: 80%;
        height: 330px;
        bottom: -33px;
    }

    .myswiper{
        width: 66%;
    }

    .myswiper-slider{
        height: 285px;
    }
}

@media screen and (min-width: 821px) and (max-width: 992px) {
    .laptop-img {
        width: 80%;
        height: 385px;
        bottom: -38px;
    }

    .myswiper{
        width: 66%;
    }

    .myswiper-slider{
        height: 333px;
    }
}

@media screen and (min-width: 993px) and (max-width: 1250px){
    .laptop-img {
        width: 61%;
        height: 385px;
        bottom: -38px;
    }

    .myswiper-slider{
        height: 333px;
    }
}

@media screen and (min-width: 1251px){
    .laptop-img {
        width: 61%;
        height: 500px;
        bottom: -50px;
    }

    .myswiper-slider{
        height: 431px;
    }
} */`, "",{"version":3,"sources":["webpack://./src/app/components/HomePageCarousel/style.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,8BAA8B;AAClC;;AAEA;IACI;QACI,aAAa;QACb,mBAAmB;IACvB;AACJ;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,0BAA0B;IAC1B,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,uDAAuD;IACvD,qBAAqB;IACrB,6BAA6B;IAC7B,oCAAoC;AACxC;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,gBAAgB;IAChB,0BAA0B;IAC1B,oBAAoB;IACpB,qBAAqB;IACrB,yBAAyB;IACzB,yBAAyB;IACzB,uBAAuB;IACvB,4BAA4B;AAChC;;AAEA;IACI,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,gBAAgB;;AAEpB;;AAEA;IACI,eAAe;IACf,uBAAuB;IACvB,sBAAsB;IACtB,2BAA2B;;IAE3B;;OAEG;AACP;;AAEA;IACI,aAAa;IACb,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,yBAAyB;IACzB,UAAU;IACV,oCAAoC;IACpC,YAAY;AAChB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,oBAAoB;AACxB;;;AAGA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,WAAW;IACX,gBAAgB;;AAEpB;;AAEA;IACI;QACI,YAAY;QACZ,iBAAiB;IACrB;GACD;IACC,YAAY;IACZ,aAAa;GACd;;GAEA;IACC,YAAY;IACZ,aAAa;GACd;AACH;;AAEA;IACI;QACI,iBAAiB;IACrB;IACA;KACC,YAAY;KACZ,aAAa;IACd;;IAEA;KACC,YAAY;KACZ,aAAa;KACb,SAAS;IACV;CACH;;AAED;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA0GG","sourcesContent":["* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n}\n\n.carousel {\n    position: relative;\n    width: calc(min(90rem, 90%));\n    margin: 0 auto;\n    min-height: 100vh;\n    column-gap: 3rem;\n    padding-block: min(20vh, 3rem);\n}\n\n@media screen and (min-width: 48rem) {\n    .carousel {\n        display: flex;\n        align-items: center;\n    }\n}\n\n.carousel-content span {\n    text-transform: uppercase;\n    letter-spacing: 1.5px;\n    font-size: 1rem;\n    color: #717171;\n}\n\n.carousel-content h1 {\n    text-transform: capitalize;\n    letter-spacing: 0.8px;\n    font-size: 4rem;\n    line-height: 1.1;\n    background-color: #00a4aa;\n    background-image: linear-gradient(45deg, #00a4aa, #000);\n    background-size: 100%;\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n}\n\n.carousel-content hr {\n    display: block;\n    background: #00a4aa;\n    height: 0.25rem;\n    width: 6.25rem;\n    border: none;\n    margin: 1.125rem 0 1.875rem 0;\n}\n\n.carousel-content p {\n    line-height: 1.6;\n}\n\n.slider-btn {\n    display: inline-block;\n    color: #717171;\n    background: #fff;\n    padding: 0.625rem 1.875rem;\n    margin-top: 2.125rem;\n    text-decoration: none;\n    text-transform: uppercase;\n    border: 2px solid #c2c2c2;\n    border-radius: 3.125rem;\n    transition: 0.3s ease-in-out;\n}\n\n.slider-btn:hover {\n    border: 0.125rem solid #00a4aa;\n    color: #00a4aa;\n}\n\n.swiper-container {\n    width: 100%;\n    height: 470px;\n    max-height: 470px;\n    display: flex;\n    justify-content: center;\n    position: relative;\n    margin-bottom: -25px;\n}\n\n.myswiper {\n    width: 100%;\n    max-width: 720px;\n\n}\n\n.myswiper-slider {\n    width: 18.75rem;\n    /* height: 28.125rem; */\n    background-size: cover;\n    background-position: center;\n\n    /* @media screen and (max-width: 992px) {\n        height: 160px;\n    } */\n}\n\n.myswiper-slider div {\n    display: none;\n    opacity: 0;\n    padding-bottom: 0.625rem;\n}\n\n.swiper-slide-active div {\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n    opacity: 1;\n    background-color: rgba(0, 0, 0, 0.5);\n    height: 100%;\n}\n\n.swiper-slide-active div a {\n    align-self: flex-start;\n}\n\n.myswiper-slider h2 {\n    color: #fff;\n    font-weight: 400;\n    font-size: 1.4rem;\n    line-height: 1.4;\n    margin-bottom: 0.625rem;\n    padding: 0 0 0 1.563rem;\n    text-transform: uppercase;\n}\n\n.myswiper-slider p {\n    color: #dadada;\n    padding: 0 1.563rem;\n    line-height: 1.6;\n    font-size: 0.75rem;\n}\n\n.myswiper-slider a {\n    margin: 1.25rem 1.5rem 3.5rem;\n}\n\n.myswiper-slider a:hover {\n    color: #00a4aa;\n}\n\n.swiper-pagination-bullet,\n.swiper-pagination-bullet-active {\n    background: #fff;\n}\n\n.swiper-slide-prev{\n    opacity: 0.5;\n}\n\n.swiper-slide-next{\n    opacity: 0.5;\n}\n\n.swiper-slide-active{\n    opacity: 1;\n}\n\n.swiper-container .swiper-slide img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    object-position: top;\n}\n\n\n.laptop-img {\n    position: absolute;\n    top: -15px;\n    z-index: 10;\n    width: 100%;\n    max-width: 860px;\n\n}\n\n@media screen and (min-width: 576px) and (max-width: 992px) {\n    .swiper-container {\n        height: auto;\n        max-height: 290px;\n    }\n   .swiper-container  .myswiper {\n    width: 470px;\n    height: 290px;\n   }\n\n   .laptop-img  {\n    width: 570px;\n    height: 340px;\n   }\n}\n\n@media screen and  (max-width: 576px) {\n    .swiper-container {\n        max-height: 175px;\n    }\n    .swiper-container  .myswiper {\n     width: 260px;\n     height: 175px;\n    }\n \n    .laptop-img  {\n     width: 320px;\n     height: 200px;\n     top: -5px;\n    }\n }\n\n/* @media screen and (min-width: 320px) and (max-width: 420px) {\n    .laptop-img {\n        width: 92%;\n        height: 185px;\n        bottom: -18px;\n    }\n\n    .myswiper {\n        width: 75%;\n    }\n}\n\n@media screen and (min-width: 421px) and (max-width: 520px) {\n    .laptop-img {\n        width: 70%;\n        height: 185px;\n        bottom: -18px;\n    }\n\n    .myswiper{\n        width: 58%;\n    }\n}\n\n@media screen and (min-width: 521px) and (max-width: 620px) {\n    .laptop-img {\n        width: 60%;\n        height: 185px;\n        bottom: -18px;\n    }\n\n    .myswiper{\n        width: 50%;\n    }\n}\n\n@media screen and (min-width: 621px) and (max-width: 720px) {\n    .laptop-img {\n        width: 80%;\n        height: 330px;\n        bottom: -33px;\n    }\n\n    .myswiper{\n        width: 66%;\n    }\n\n    .myswiper-slider{\n        height: 285px;\n    }\n}\n\n@media screen and (min-width: 721px) and (max-width: 820px) {\n    .laptop-img {\n        width: 80%;\n        height: 330px;\n        bottom: -33px;\n    }\n\n    .myswiper{\n        width: 66%;\n    }\n\n    .myswiper-slider{\n        height: 285px;\n    }\n}\n\n@media screen and (min-width: 821px) and (max-width: 992px) {\n    .laptop-img {\n        width: 80%;\n        height: 385px;\n        bottom: -38px;\n    }\n\n    .myswiper{\n        width: 66%;\n    }\n\n    .myswiper-slider{\n        height: 333px;\n    }\n}\n\n@media screen and (min-width: 993px) and (max-width: 1250px){\n    .laptop-img {\n        width: 61%;\n        height: 385px;\n        bottom: -38px;\n    }\n\n    .myswiper-slider{\n        height: 333px;\n    }\n}\n\n@media screen and (min-width: 1251px){\n    .laptop-img {\n        width: 61%;\n        height: 500px;\n        bottom: -50px;\n    }\n\n    .myswiper-slider{\n        height: 431px;\n    }\n} */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
